export default "__VITE_ASSET__CQc3c1ce__"